import PricingDisclaimer from '../PricingDisclaimer';
import React from 'react';
import { csrpDescription } from '../../QuoteView/QuoteList';
import styles from './index.module.scss';
import { toCurrencyString } from '../../../utils';

export default function Pricing({ product, disclaimer = true }) {
  if (!product.price || !product.leasingPrice) {
    return null;
  }

  const formattedMonthlyPrice = toCurrencyString(product.leasingPrice);
  const formattedPrice = toCurrencyString(product.price);

  return (
    <div className={styles.pricing}>
      <table className={styles.pricingTable}>
        <tbody>
          <tr>
            <td>
              <div title={csrpDescription}>Cisco suggested retail price *</div>
            </td>
            <td>
              <div className={styles.monthlyPrice}>{`${formattedMonthlyPrice}/mo`}</div>
              <div className={styles.price}>{`${formattedPrice}`}</div>
            </td>
          </tr>
        </tbody>
      </table>
      {disclaimer && <PricingDisclaimer />}
    </div>
  );
}
